module.exports = __webpack_public_path__ + "static/media/ambassador-import.4f1150ee.csv";